import "dayjs/locale/ja";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/types";
import { ACCESS_TOKEN_NAME, UserRole } from "../../../shared/constants";
import AdminHome from "./Pages/AdminHome";
import UserHome from "./Pages/UserHome";
import LandingPage from "../../LandingPage";

const BillGateHome = () => {
  const { loggedInUser } = useSelector((state: RootState) => state.global);
  // const accessToken = localStorage.getItem(ACCESS_TOKEN_NAME) || "";
  // debugger;
  return (
    <>
      {!loggedInUser && <LandingPage />}
      {loggedInUser?.role === UserRole.Admin && <AdminHome />}
      {loggedInUser?.role === UserRole.Imam && <UserHome />}
    </>
  );
};

export default BillGateHome;
